<template>
  <div>
    <div v-if="projectStore.activeProject.State == 0" class="p-3">
      <b-alert show variant="danger">
        Das
        <b>Änderungsmanagement</b>
        steht ausschließlich in der
        <b>Ausführungsphase</b>
        zur Verfügung.
        <br />
        <b-button class="mt-3" @click="$router.go(-1)">Zurück</b-button>
      </b-alert>
    </div>
    <div v-else>
      <!------------------
            HEADER
    -------------------->
      <div class="bg-white p-2 pt-3 pb-3 d-flex align-items-center page-header" ref="pageHeader">
        <div class="col">
          <div>
            <h4>
              <b-icon class="me-2" icon="clipboard-plus"></b-icon>
              Änderungsmanagement
            </h4>
          </div>
          <!-- <div class="text-uppercase text-secondary"><small>Kostenkontrolleinheiten</small></div> -->
        </div>
        <div class="col-auto">
          <div class="form-inline">
            <!---------------------------------
            HEADER ACTION BUTTONS
        ---------------------------------->
            <!-- Neues Änderungstestat -->
            <b-button
              size="sm"
              variant="light"
              class=""
              @click="openNewRecordForm"
              v-if="
                projectStore
                  ? projectStore.activeProject.State == 1 && ($root.$user.isPlaner || $root.$user.isAdmin)
                  : false
              "
            >
              <b-icon icon="plus" variant="dark" class="mr-1"></b-icon>
              Änderungstestat
            </b-button>
            <b-button
              :disabled="!isDeleteButtonEnabled"
              size="sm"
              variant="light"
              class="ml-2"
              @click="deleteSelected()"
              v-if="$root.$user.isPlaner || $root.$user.isAdmin"
            >
              <b-icon icon="trash" variant="dark" class="mr-1"></b-icon>
              Löschen
            </b-button>

            <b-button size="sm" variant="light" class="ml-2">
              <b-icon @click="loadPats" icon="arrow-repeat" variant="dark" class=""></b-icon>
            </b-button>

            <!-- SEARCH FIELD  -->
            <b-input-group class="ml-2 header-search-field">
              <b-form-input
                type="search"
                size="sm"
                v-model.lazy="searchText"
                :class="{ 'bg-primary-light-3': searchText !== '' }"
                placeholder="Suchbegriff eingeben..."
              ></b-form-input>
              <template #prepend>
                <b-input-group-text>
                  <b-icon variant="dark" icon="search" />
                </b-input-group-text>
              </template>
            </b-input-group>
            <!-- FILTER BUTTON  -->
            <b-button
              size="sm"
              :variant="filterToggle == true ? 'primary' : 'light'"
              class="ml-2"
              :pressed="filterToggle"
              :disabled="!isDeleteButtonEnabled"
              @click="filterRecords"
            >
              <b-icon icon="funnel"></b-icon>
            </b-button>
            <!-- COPY TO EXCEL  -->
            <b-button
              size="sm"
              variant="light"
              class="ml-2"
              @click="copyToExcel"
              title="In Zwischenablage für Excel kopieren"
            >
              <!-- Custom copy-to-spreadsheet icon: back sheet (copy) + front sheet with table grid -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="currentColor"
                aria-hidden="true"
                style="vertical-align: -0.125em"
              >
                <path
                  d="M6 0a1.5 1.5 0 0 0-1.5 1.5V3H6V1.5a.5.5 0 0 1 .5-.5h4v2A1.5 1.5 0 0 0 12 4.5h2v6a.5.5 0 0 1-.5.5H12v1h1.5A1.5 1.5 0 0 0 15 10.5V3.914a1.5 1.5 0 0 0-.44-1.06L12.147.439A1.5 1.5 0 0 0 11.086 0H6zm5.5 1.207L13.293 3H12a.5.5 0 0 1-.5-.5V1.207z"
                />
                <path
                  d="M1.5 5A1.5 1.5 0 0 0 0 6.5v8A1.5 1.5 0 0 0 1.5 16h7A1.5 1.5 0 0 0 10 14.5v-8A1.5 1.5 0 0 0 8.5 5h-7zM1 6.5a.5.5 0 0 1 .5-.5H4v2.25H1V6.5zm4-.5h3.5a.5.5 0 0 1 .5.5v1.75H5V6zM1 9.25h3v2.5H1v-2.5zm4 0h4v2.5H5v-2.5zM1 12.5h3V15H1.5a.5.5 0 0 1-.5-.5v-2zm4 0h4v2a.5.5 0 0 1-.5.5H5v-2.5z"
                />
              </svg>
            </b-button>
            <!-- HELP ICON  -->
            <b-button
              size="sm"
              variant="light"
              class="ml-2"
              href="https://www.bauvisor.de/projekt-aenderungs-testate-paet/"
              target="_blank"
            >
              <b-icon icon="question-circle" variant="dark"></b-icon>
            </b-button>
          </div>
        </div>
      </div>

      <div class="main-canvas" v-show="!isLoading">
        <BudgetSummaryWidget />
        <b-table
          :filter-included-fields="['Ordinal', 'DisplayName', 'DecisionText']"
          small
          :items="pats"
          :fields="patsFields"
          hover
          @row-clicked="onTableRowClicked"
          bordered
          class="bg-white shadow-muted-super sum-header"
          head-variant="light"
          show-empty
          :filter="searchText"
          :tbody-tr-class="getTrClass"
          :responsive="true"
          ref="theTable"
          @filtered="handleFilterChange"
          :sticky-header="tableHeight"
        >
          <template #empty>
            <div class="block text-center text-muted p-5">Keine Änderungstestate vorhanden.</div>
          </template>
          <template #cell(DisplayName)="data">
            <div
              v-if="data.item.Description"
              v-b-popover.hover.bottom="data.item.Description"
              title="Beschreibung"
              @click="$router.push(`/changemanagement/${data.item.DbId}?t=0`)"
            >
              {{ data.item.DisplayName }}
            </div>
            <div v-else @click="$router.push(`/changemanagement/${data.item.DbId}?t=0`)">
              {{ data.item.DisplayName }}
            </div>
          </template>
          <template #cell(BudgetDemand)="data">
            {{ formatCurrency(data.item.BudgetDemand) }}
          </template>
          <template #cell(Budget)="data">
            {{ formatCurrency(data.item.Budget) }}
          </template>
          <template #cell(RiskAmount)="data">
            <div
              v-if="data.item.Description"
              v-b-popover.hover.bottom="data.item.RiskDescription"
              title="Risikobeschreibung"
              @click="$router.push(`/changemanagement/${data.item.DbId}?t=0`)"
            >
              {{ formatCurrency(data.item.RiskAmount) }}
            </div>
            <div v-else @click="$router.push(`/changemanagement/${data.item.DbId}?t=0`)">
              {{ formatCurrency(data.item.RiskAmount) }}
            </div>
          </template>
          <template #cell(BudgetSaldo)="data">
            {{ formatCurrency(data.item.BudgetSaldo) }}
          </template>
          <template #cell(BudgetAllocated)="data">
            {{ formatCurrency(data.item.BudgetAllocated) }}
          </template>
          <template #cell(Date)="data">
            {{ $utils.SQLDateToGermanDate(data.item.Date) }}
          </template>
          <template #cell(DecisionDate)="data">
            {{ data.item.DecisionDate ? $utils.SQLDateToGermanDate(data.item.DecisionDate) : '-' }}
          </template>
          <template #cell(DecisionText)="data">
            <div
              v-if="data.item.DecisionComment"
              v-b-popover.hover.bottom="data.item.DecisionComment"
              title="Kommentar Entscheidung"
              @click="$router.push(`/changemanagement/${data.item.DbId}?t=1`)"
            >
              {{ data.item.DecisionText ? data.item.DecisionText : 'Offen' }}
            </div>
            <div v-else @click="$router.push(`/changemanagement/${data.item.DbId}?t=1`)">
              {{ data.item.DecisionText ? data.item.DecisionText : 'Offen' }}
            </div>
          </template>
          <template #head(checked)>
            <b-form-checkbox
              class="ml-2"
              :disabled="pats.length == 0"
              v-model="checkedAllTableEntries"
              @change="onCheckAllTableEntries"
            ></b-form-checkbox>
          </template>
          <template #head(Budget)="data">
            <div>
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': searchText != '' || filterToggle }"
            >
              <b-icon icon="funnel-fill" v-if="searchText != '' || filterToggle" />
              {{ formatCurrency(totalBudget) }}
            </div>
          </template>
          <template #head(BudgetAllocated)="data">
            <div>
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': searchText != '' || filterToggle }"
            >
              <b-icon icon="funnel-fill" v-if="searchText != '' || filterToggle" />
              {{ formatCurrency(totalAllocated) }}
            </div>
          </template>
          <template #head(BudgetSaldo)="data">
            <div>
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': searchText != '' || filterToggle }"
            >
              <b-icon icon="funnel-fill" v-if="searchText != '' || filterToggle" />
              {{ formatCurrency(totalRemaining) }}
            </div>
          </template>
          <template #cell(checked)="data">
            <b-form-checkbox
              class="ml-2"
              @change="onCheckedItemChange(data.item)"
              v-model="data.item.checked"
            ></b-form-checkbox>
          </template>
          <template #cell(actions)="data">
            <b-icon
              class="action-button text-grey"
              style="width: 18px; height: 18px"
              icon="arrow-right"
              title="Auftrag öffnen"
              @click.stop="$router.push(`/changemanagement/${data.item.DbId}?t=0`)"
            />
            <!--- D E L E T E  --->
            <b-icon
              icon="trash"
              variant="grey"
              class="action-button ml-2"
              @click="deletePATWithConfirmation(data.item)"
              v-if="$root.$user.isPlaner || $root.$user.isAdmin"
            ></b-icon>
          </template>
          <template #custom-foot="" v-if="projectStore ? projectStore.activeProject.State == 1 : false">
            <b-tr v-if="$root.$user.isPlaner || $root.$user.isAdmin">
              <b-td colspan="12" class="text-center">
                <b-button size="sm" variant="grey" class="rounded-circle p-2" @click="openNewRecordForm">
                  <b-icon icon="plus" scale="1.5"></b-icon>
                </b-button>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td colspan="12">
                <div class="text-muted small " style="margin-left:9px; margin-top:2px;" v-if="!isLoading">
                  {{ displayedItemsCount }} Zeilen dargestellt, {{ selectedRows.length }} Zeilen ausgewählt.
                </div>
              </b-td>
            </b-tr>
          </template>
        </b-table>
      </div>
      <!------------------------
          MODAL DIALOGS
    -------------------------->
    </div>
  </div>
</template>
<script>
import projectStore from '@/store/Projects';
import settingsStore from '@/store/Settings';
import PatsService from '@/service/PatsService';
import BudgetSummaryWidget from '@/components/BudgetSummaryWidget';
import AppState from '@/store/App.js';
import { copyTableToClipboard } from '@/utils/tableExport';
export default {
  components: {
    BudgetSummaryWidget
  },

  data() {
    return {
      pats: [],
      selectedRows: [],
      displayedItemsCount: 0,
      filterToggle: false,
      patsFields: [
        {
          key: 'checked',
          label: '',
          tdClass: 'text-center align-top',
          thClass: 'text-center align-top noselect',
          thStyle: 'width: 50px;'
        },
        {
          key: 'Ordinal',
          label: 'PÄT-Nr.',
          thClass: 'align-top',
          tdClass: 'action-button',
          thStyle: 'width:70px',
          sortable: true
        },
        {
          key: 'Date',
          label: 'Datum',
          formatter: x => (x ? this.$utils.SQLDateToGermanDate(x) : ''),
          thClass: 'align-top',
          tdClass: 'action-button',
          sortable: true
        },
        { key: 'DisplayName', label: 'Bezeichnung', thClass: 'align-top', tdClass: ' action-button', sortable: true },
        {
          key: 'BudgetDemand',
          label: 'Budgetbedarf',
          formatter: x => this.formatCurrency(x),
          thClass: 'align-top',
          tdClass: 'action-button text-right',
          sortable: true
        },
        {
          key: 'RiskAmount',
          label: 'Risiko',
          formatter: x => this.formatCurrency(x),
          thClass: 'align-top',
          tdClass: 'action-button text-right text-nowrap',
          sortable: true
        },
        {
          key: 'DecisionText',
          label: 'Entscheidung',
          thClass: 'align-top',
          tdClass: 'action-button bg-primary-light section-seperator',
          sortable: true
        },
        {
          key: 'DecisionDate',
          label: 'Datum',
          formatter: x => (x ? this.$utils.SQLDateToGermanDate(x) : ''),
          thClass: 'align-top',
          tdClass: 'action-button bg-primary-light',
          sortable: true
        },
        {
          key: 'Budget',
          label: 'Freigabebudget',
          formatter: x => this.formatCurrency(x),
          thClass: 'align-top text-right noselect',
          thStyle: '',
          tdClass: 'action-button text-right bg-primary-semi-light section-seperator',
          sortable: true
        },
        {
          key: 'BudgetAllocated',
          label: 'Zugewiesen',
          formatter: x => this.formatCurrency(x),
          thClass: 'align-top text-right',
          tdClass: 'action-button text-right bg-primary-semi-light',
          sortable: true
        },
        {
          key: 'BudgetSaldo',
          label: 'Restbudget',
          formatter: x => this.formatCurrency(x),
          thClass: 'align-top text-right',
          tdClass: 'action-button text-right bg-primary-semi-light',
          sortable: true
        },

        {
          key: 'Actions',
          label: 'Aktionen',
          tdClass: 'text-center align-middle section-seperator',
          thStyle: 'width: 80px',
          thClass: 'align-top noselect'
        }
      ],
      isLoading: true,
      tableHeight: '500px',
      projectStore,
      searchText: '',
      isDeleteButtonEnabled: false,
      checkedAllTableEntries: false,
      totalBudget: 0,
      totalAllocated: 0,
      totalRemaining: 0
    };
  },
  methods: {
    async copyToExcel() {
      // Export the currently displayed rows in table order (search filter and sorting applied).
      const table = this.$refs.theTable;
      const items = (table && (table.computedItems || table.sortedItems)) || this.pats;
      try {
        await copyTableToClipboard(this.patsFields, items);
        this.$showSuccess(this, 'Excel-Export', items.length + ' Zeile(n) in die Zwischenablage kopiert.');
      } catch (error) {
        this.$showError(this, error.toString());
      }
    },
    handleFilterChange(visibleItems) {
      // remove check from all non-visible fields
      const checkItems = this.pats.filter(x => x.checked == true);
      checkItems.forEach(item => {
        if (visibleItems.findIndex(x => x.DbId == item.DbId) == -1) {
          item.checked = false;
          // also remove from selected rows
          const index = this.selectedRows.findIndex(x => x.DbId == item.DbId);
          if (index != -1) {
            this.selectedRows.splice(index, 1);
          }
        }
      });
      // are all visible rows checked, then also check the "check all" checkbox
      let allChecked = true;
      visibleItems.forEach(item => {
        if (item.checked != true) allChecked = false;
      });
      this.checkedAllTableEntries = visibleItems.length > 0 && allChecked;

      this.recalcTotals(visibleItems);
    },
    loadPats() {
      this.isLoading = true;
      this.totalBudget = 0;
      this.totalAllocated = 0;
      this.totalRemaining = 0;

      PatsService.getAll()
        .then(pats => {
          var allChecked = pats.length > 0;
          this.pats = pats.map(x => {
            if (!x.DecisionText || x.DecisionText == '') x.DecisionText = 'Offen';
            x.checked = this.selectedRows.find(y => y.DbId == x.DbId) != null;
            if (x.checked !== true) allChecked = false;
            this.totalBudget += parseFloat(x.Budget);
            this.totalAllocated += parseFloat(x.BudgetAllocated);
            this.totalRemaining += parseFloat(x.BudgetSaldo);

            return x;
          });
          if (this.filterToggle) {
            allChecked = true;
            this.patsBackup = [...this.pats];
            this.pats = this.pats.filter(x => {
              return x.checked == true;
            });
          }
          this.checkedAllTableEntries = allChecked;
          //this.tableHeight = window.innerHeight - 300 + 'px';
          this.$nextTick(() => this.onWindowResize());
          this.recalcTotals();
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        })
        .finally(() => {
          this.isLoading = false;
          if (AppState.scrollPosition[this.$route.path])
            this.$refs.theTable.$el.scrollTo({
              top: AppState.scrollPosition[this.$route.path][0],
              left: AppState.scrollPosition[this.$route.path][1]
            });
        });
    },
    deletePAT(item, showSuccessMessage = true) {
      PatsService.delete(item)
        .then(() => {
          this.$utils.deleteItemFromArray(this.pats, x => x.DbId == item.DbId);

          if (showSuccessMessage)
            this.$showSuccess(
              this,
              'Änderungstestate löschen',
              'Änderungstestat "' + item.Ordinal + ' ' + item.DisplayName + '" erfolgreich gelöscht.'
            );
          return true;
        })
        .catch(err => {
          this.$set(item, 'hasError', true); // this will re-activly set hasError, so the table bg color change is triggered
          const that = this;
          setTimeout(() => {
            that.$set(item, 'hasError', false);
          }, 3000);
          if (err.response) this.$showError(this, err.response.data);
          else this.$showError(this, err.toString());
          return false;
        });
    },
    deletePATWithConfirmation(item) {
      this.$bvModal
        .msgBoxConfirm('Soll das Änderungstestat wirklich gelöscht werden?', {
          title: 'Änderungstestate löschen',
          okTitle: 'Bestätigen',
          cancelTitle: 'Abbrechen',
          okVariant: 'danger',

          centered: true
        })
        .then(confirmed => {
          if (confirmed) {
            this.deletePAT(item, true);
            this.recalcTotals();
          }
        });
    },

    deleteSelected() {
      let itemsToDelete = this.pats.filter(x => {
        return x.checked;
      });

      if (itemsToDelete.length == 1) {
        this.deletePAT(itemsToDelete[0]);
        this.isDeleteButtonEnabled = false;
        this.checkedAllTableEntries = false;
        return;
      }

      const h = this.$createElement;
      var question =
        'Sollen die markierten ' +
        itemsToDelete.length +
        ' Änderungstestate wirklich gelöscht werden?' +
        '<br><div class="alert alert-danger mt-2 mb-1 p-2" role="alert"><strong>Achtung:</strong> Falls diese Änderungstestate bereits auf VEs budgetiert wurden, müssen diese Budgetzuordnungen vorab gelöscht werden!</div>';
      const messageVNode = h('div', { domProps: { innerHTML: question } });
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Änderungstestate löschen',
          okTitle: 'Bestätigen',
          cancelTitle: 'Abbrechen',
          okVariant: 'danger',

          centered: true
        })
        .then(confirmed => {
          if (confirmed) {
            itemsToDelete.forEach(item => {
              this.deletePAT(item, itemsToDelete.length <= 5); // show success messages only, if less than 5 items to be deleted
            });

            if (this.pats.length == 0) this.checkedAllTableEntries = false;
            if (itemsToDelete.length > 5)
              this.$showSuccess(this, 'Änderungstestate löschen', ' Änderungstestate erfolgreich gelöscht.');
          }
          this.isDeleteButtonEnabled = false;
          this.checkedAllTableEntries = false;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.pats.map(x => {
            x.checked = false;
            return x;
          });
          this.recalcTotals();
          setTimeout(() => {
            this.$eventBus.$emit('budget:changed');
          }, 400);
        });
    },
    openNewRecordForm() {
      this.$router.push('/changemanagement/create');
    },
    formatCurrency(number) {
      return this.$utils.numberToCurrency(number, settingsStore.settings['Centbetraege']);
    },
    recalcTotals(items) {
      if (!items) items = this.pats;
      this.totalBudget = 0;
      this.totalAllocated = 0;
      this.totalRemaining = 0;
      items.map(x => {
        this.totalBudget += parseFloat(x.Budget);
        this.totalAllocated += parseFloat(x.BudgetAllocated);
        this.totalRemaining += parseFloat(x.BudgetSaldo);
      });
      this.displayedItemsCount = items.length;
    },
    onWindowResize() {
      this.tableHeight = window.innerHeight - 300 + 'px';
    },
    onTableRowClicked(item, idx, evt) {
      if (!evt.target.cellIndex || evt.target.cellIndex == 11) return;
      if (evt.target.cellIndex >= 9 && evt.target.cellIndex <= 10) {
        if (item.DecisionText == 'Freigegeben') {
          this.$router.push(`/changemanagement/${item.DbId}?t=2`);
        } else {
          this.$router.push(`/changemanagement/${item.DbId}?t=1`);
        }
      } else if (evt.target.cellIndex >= 6 && evt.target.cellIndex <= 8) {
        this.$router.push(`/changemanagement/${item.DbId}?t=1`);
      } else {
        this.$router.push(`/changemanagement/${item.DbId}`);
      }
    },
    onCheckAllTableEntries() {
      this.isDeleteButtonEnabled = this.checkedAllTableEntries;
      this.pats.map(x => {
        return (x.checked = this.checkedAllTableEntries);
      });
      this.selectedRows = this.pats.filter(x => x.checked == true);
    },
    onCheckedItemChange(item) {
      this.isDeleteButtonEnabled = false;
      this.selectedRows = this.pats.filter(x => x.checked == true);
      for (let i = 0; i < this.pats.length; i++) {
        if (this.pats[i].checked) {
          this.isDeleteButtonEnabled = true;
          break;
        }
      }
      if (!item.checked) {
        return (this.checkedAllTableEntries = false);
      }

      for (let i = 0; i < this.pats.length; i++) {
        if (!this.pats[i].checked) {
          return (this.checkedAllTableEntries = false);
        }
      }

      this.checkedAllTableEntries = true;
    },
    getTrClass(item) {
      if (!item) return;
      return item.hasError ? 'invalid' : '';
    },
    filterRecords() {
      if (!this.filterToggle) {
        this.filterToggle = true;
        this.patsBackup = [...this.pats];
        this.pats = this.pats.filter(x => {
          return x.checked == true;
        });
        this.checkedAllTableEntries = true;
      } else {
        this.filterToggle = false;
        this.pats = this.patsBackup;
        this.checkedAllTableEntries = this.selectedRows.length == this.pats.length;
      }
      this.recalcTotals(this.pats);
    }
  },
  created() {
    this.$eventBus.$on('projectSwitched', () => {
      this.searchText = '';
    });
  },
  activated() {
    window.addEventListener('resize', this.onWindowResize, false); // listen for windows size changes, to re-compute height of controls
    this.loadPats();
    AppState.isLoading = false;
  },
  deactivated() {
    window.removeEventListener('resize', this.onWindowResize, false);
  },
  beforeRouteLeave(to, from, next) {
    AppState.scrollPosition[from.path] = [this.$refs.theTable.$el.scrollTop, this.$refs.theTable.$el.scrollLeft];
    next();
  }
};
</script>
<style>
.bg-transparent {
  background-color: var(--bauvisor-light) !important;
}
.btn-grey {
  background-color: #eee;
  color: #888;
}
.section-seperator {
  border-left: 2px solid #dee2e6 !important;
}
</style>
